import { ShopperAgentChannelKind } from "@redotech/crdb-enums/shopper-ai/shopper-agent-channel-kind";
import * as z from "zod";

export const ShopperAgentMessageChannelKinds = [
  ShopperAgentChannelKind.Sms,
  ShopperAgentChannelKind.Email,
] as const;
export type ShopperAgentMessageChannelKind =
  (typeof ShopperAgentMessageChannelKinds)[number];
export const ShopperAgentMessageChannelKind = ShopperAgentMessageChannelKinds;

const shopperAgentMessageSmsChannelSchema_ = z.object({
  kind: z.literal(ShopperAgentChannelKind.Sms),
  subscribers: z.boolean().optional(),
  extendedOutreach: z.boolean().optional(),
});
export interface ShopperAgentMessageSmsChannel extends z.infer<
  typeof shopperAgentMessageSmsChannelSchema_
> {}

const shopperAgentMessageEmailChannelSchema_ = z.object({
  kind: z.literal(ShopperAgentChannelKind.Email),
  subscribers: z.undefined().optional(),
  extendedOutreach: z.undefined().optional(),
});
export interface ShopperAgentMessageEmailChannel extends z.infer<
  typeof shopperAgentMessageEmailChannelSchema_
> {}

export const shopperAgentMessageChannelSchema = z
  .discriminatedUnion("kind", [
    shopperAgentMessageSmsChannelSchema_,
    shopperAgentMessageEmailChannelSchema_,
  ])
  .superRefine((channel, ctx) => {
    if (
      channel.kind === ShopperAgentChannelKind.Sms &&
      channel.subscribers === false &&
      channel.extendedOutreach !== true
    ) {
      ctx.addIssue({
        code: "custom",
        message: "Text steps require at least one audience",
      });
    }
  });
export type ShopperAgentMessageChannel = z.infer<
  typeof shopperAgentMessageChannelSchema
>;

/** Only explicit true bypasses Sentinel. */
export const DEFAULT_SHOPPER_AGENT_MESSAGE_ALWAYS_SEND = false;

export function shopperAgentMessageAlwaysSend(
  alwaysSend: boolean | null | undefined,
): boolean {
  return alwaysSend === true;
}

export function shopperAgentMessageIncludesSubscribers(
  channel: ShopperAgentMessageChannel,
): boolean {
  return (
    channel.kind === ShopperAgentChannelKind.Sms &&
    channel.subscribers !== false
  );
}

export function shopperAgentMessageIncludesExtendedOutreach(
  channel: ShopperAgentMessageChannel,
): boolean {
  return (
    channel.kind === ShopperAgentChannelKind.Sms &&
    channel.extendedOutreach === true
  );
}
